import loadable from '@loadable/component';

// 懒加载组件
const DeliveryQuery = loadable(() => import('./deliveryQuery/DeliveryQuery'));
const DeliveryModify = loadable(() => import('./deliveryQuery/deliveryModify/DeliveryModify'));

export const subRoutes = [
  {
    // 253002耗材发货单查询
    path: '/DeliveryQuery',
    component: DeliveryQuery
  },
  {
    // 耗材发货单明细修改
    path: '/DeliveryModify',
    component: DeliveryModify
  }
];
